<template>
  <div class="base-map">
    <div class="choose">
      <div class="dot-wrap">
        <span
          @click="getDot"
          :class="{'active':index==1}"
        >
          获取坐标点
        </span>
        <span
          @click="track"
          :class="{'active':index==2}"
        >
          获取运动轨迹
        </span>

      </div>
      <el-select
        v-if="index ==2"
        v-model="equipID"
        placeholder="请选择设备"
        @change="chagneEquipment"
      >
        <el-option
          v-for="(item,index) in mapList"
          :key="index"
          :label="item.deviceName"
          :value="item.deviceId"
        >
        </el-option>
      </el-select>
      <div class="select-container-box" v-if="index ==2">
        <span>时间&nbsp;&nbsp;</span>
        <el-date-picker
          size="small"
          v-model="start"
          type="date"
          :clearable="false"
          placeholder="开始日期"
          value-format="yyyy-MM-dd"
          :picker-options="pickerTimeOptions">
        </el-date-picker>
      </div>
      <div class="select-container" v-if="index ==2">
        <span>至</span>
      </div>
      <div class="select-container-box" v-if="index ==2">
        <el-date-picker
          size="small"
          v-model="end"
          type="date"
          :clearable="false"
          placeholder="结束日期"
          value-format="yyyy-MM-dd"
          :picker-options="pickerTimeOptions">
        </el-date-picker>
      </div>
      <div  v-if="index ==2" class="search" @click="search">查询</div>
    </div>
    <div id="container"></div>
  </div>
</template>

<script>
import maps from '../../store/modules/maps.js'
import equipmentV2 from '../../store/modules/equipmentV2'
import { mapActions, mapState } from 'vuex'
export default {
  name: 'BaseMap',
  data () {
    return {
      index: 1,
      equipID: '',
      mapList: [],
      start: new Date(), // 开始时间
      end: new Date(), // 结束时间
      pickerTimeOptions: {
        // 限制日期
        disabledDate (time) {
          return time.getTime() > Date.now() - 8.64e6
        }
      }
    }
  },
  watch: {
    basic: {
      handler () {
        this.getDot()
      },
      immediate: true
    }
  },
  computed: {
    ...mapState(equipmentV2, ['basic'])
  },
  async created () {
    this.mapList = await this.getDeviceLocation()
    console.log(this.mapList)
    this.equipID = this.mapList[0].id
  },
  async mounted () {
    this.getDot()
  },
  methods: {
    ...mapActions(maps, ['getDeviceLocation', 'getDeviceLocationList', 'getMapEquipmentList']),
    async getDot () {
      this.index = 1
      let coordinateList = await this.ajaxGetDeviceLocation()
      await this.initDot(coordinateList)
    },

    async initDot (coordinateList) {
      var map = new window.AMap.Map('container', {
        resizeEnable: true,
        // center: [116.397428, 39.90923],
        zoom: 20
      })
      coordinateList.forEach((latLong) => {
        console.log(latLong)
        // 实例化点标记
        function addMarker (latLong) {
          console.log(latLong)
          var marker = new window.AMap.Marker({
            icon:
              'http://ylwzn.nxin.com/images/icon_positioning.png',
            position: [latLong.longitude, latLong.latitude],
            offset: new window.AMap.Pixel(-41, -59)
          })
          marker.setMap(map)
          // 设置文本标记
          marker.setLabel({
            offset: new window.AMap.Pixel(5, -2), // 设置文本标注偏移量
            content: `<div style="color:#0077ff;font-szie:16px;">${latLong.deviceName}</div>`, // 设置文本标注内容
            direction: 'top' // 设置文本标注方位
          })
        }
        addMarker(latLong)
      })
      map.setFitView()
    },
    initMaps (data) {
      this.index = 2
      let lineArr = data
      // var lineArr = [[116.478935, 39.997761], [116.478939, 39.997825], [116.478912, 39.998549], [116.478912, 39.998549], [116.478998, 39.998555], [116.478998, 39.998555], [116.479282, 39.99856], [116.479658, 39.998528], [116.480151, 39.998453], [116.480784, 39.998302], [116.480784, 39.998302], [116.481149, 39.998184], [116.481573, 39.997997], [116.481863, 39.997846], [116.482072, 39.997718], [116.482362, 39.997718], [116.483633, 39.998935], [116.48367, 39.998968], [116.484648, 39.999861]]
      var map = new window.AMap.Map('container', {
        resizeEnable: true,
        // center: [116.397428, 39.90923],
        zoom: 20
      })
      var marker = new window.AMap.Marker({
        map: map,
        // position: [116.478935, 39.997761],
        icon: 'https://webapi.amap.com/images/car.png',
        offset: new window.AMap.Pixel(-26, -13),
        autoRotation: true,
        angle: -90
      })
      // 绘制轨迹
      var polyline = new window.AMap.Polyline({
        map: map,
        path: lineArr,
        showDir: true,
        strokeColor: '#28F', // 线颜色
        // strokeOpacity: 1,     //线透明度
        strokeWeight: 6 // 线宽
        // strokeStyle: "solid"  //线样式
      })
      console.log(polyline)

      var passedPolyline = new window.AMap.Polyline({
        map: map,
        // path: lineArr,
        strokeColor: '#AF5', // 线颜色
        // strokeOpacity: 1,     //线透明度
        strokeWeight: 6 // 线宽
        // strokeStyle: "solid"  //线样式
      })

      marker.on('moving', function (e) {
        passedPolyline.setPath(e.passedPath)
      })

      map.setFitView()

      setTimeout(() => {
        map.setZoomAndCenter(20) // 同时设置地图层级与中心点
        let last = data.length - 1
        // console.log(data[0].lat)
        // console.log(data[0].lng)
        let arr = []
        data.forEach((item) => {
          arr.push(new window.AMap.LngLat(item.lng, item.lat))
        })
        var distance = Math.round(window.AMap.GeometryUtil.distanceOfLine(arr))
        let speed = distance / 3

        var mybounds = new window.AMap.Bounds([data[0].lng, data[0].lat], [data[last].lng, data[last].lat])
        map.setBounds(mybounds)
        // map.setFitView()
        marker.moveAlong(lineArr, speed)
      }, 0)
    },
    chagneEquipment (e) {
      this.ajaxGetDeviceLocationList(e)
    },
    // 运动轨迹
    track () {
      this.index = 2
      if (this.mapList.length === 0) {
        this.mapList = []
      }
      this.equipID = this.mapList[0].deviceId
      this.ajaxGetDeviceLocationList(this.mapList[0].deviceId)
    },
    // 获取坐标点
    async ajaxGetDeviceLocation () {
      let obj = {
        FishBaseId: '',
        PondId: '',
        IsGetRealTimeData: false,
        CoordinateType: 1
      }
      try {
        let data = await this.getDeviceLocation(obj)
        return data
      } catch (err) {
        console.log('获取失败')
      }
    },
    // 获取坐标列表
    ajaxGetDeviceLocationList (id) {
      console.log(this.start)
      let obj = {
        Id: id,
        StartDate: this.$timeformatDay(this.start) + ' ' + '00:00:00',
        EndDate: this.$timeformatDay(this.end) + ' ' + '23:59:59',
        CoordinateType: 1
      }
      this.getDeviceLocationList(obj).then(data => {
        let arr = []
        data.forEach(item => {
          arr.push([item.longitude, item.latitude])
        })
        this.initMaps(arr)
      })
    },
    search () {
      this.ajaxGetDeviceLocationList(this.equipID)
    }
  }
}
</script>

<style lang="scss">
// 高德地图样式
.amap-marker-label{
  border:none;
  background: none;
}
// .amap-icon img {
//   width: 30px;
//   height: 42px;
// }
.base-map {
  padding: 12px 28px;
  .select-container{
    padding:0 8px;
  }

  .el-input__inner{
    height: 38px;
  }
  .select-container-box{
    display: flex;
    align-items: center;
    line-height: 36px;
    .el-input__inner{
      line-height: 38px;
      height: 38px;
    }
    >span{
      margin-left: 20px;
    }
  }
  .search{
    margin-left: 20px;
    padding:0 30px;
    border-radius: 4px;
    line-height: 38px;
    color: white;
    background: #0077ff;
    cursor: pointer;
  }
  .choose {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
  }
  .dot-wrap {
    width: 302px;
    margin-right: 20px;
    border-radius: 4px;
    border: 1px solid #0077ff;
    overflow: hidden;
    color:#999999;
    .active {
      color: #fff;
      background: #0077ff;
    }
    > span {
      display: inline-block;
      width: 150px;
      height: 36px;
      line-height: 36px;
      text-align: center;
      cursor: pointer;
    }
  }
  .el-input {
    width: 180px;
    // margin-left: 20px;
  }
  .el-input__inner {
    border: 1px solid #0077ff;
    color: white;
    background: none;
  }
}
#container {
  width: calc(100vw - 56px);
  height: calc(100vh - 140px);
}
</style>
